/**
 * @Email : sgarcia@ibl.mx
 * @Author: Susana Garcia Rodriguez
 * @jobTittle: Frontend
 */

import React, {useRef, useState} from 'react';
import CustomTd from '../../../../components/table/CustomTd';
import DropDownMenuItem from '../../../../components/DropDown/DropDownMenuItem';
import DropDownMenuProfile from '../../../../components/DropDown/DropDownMenuProfile';
import { DeleteIconsOptions } from '../../../../components/buttons/IconButtons';
import TableFunction from '../../../../components/table/TableFunction';
import { TABLES } from '../../../../Apis/Tables';
import CustomTh from '../../../../components/table/CustomTh';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {EMPTY_VALUES, errorMsg} from '../../../../Apis/functions';
import { DeleteItemsApi } from '../../../../reduxToolkit/Commons/CommonsApi';
import {SEARCH_MODEL} from "../../../../components/table/Model/TableModel";
import {VIEW_TYPE} from "../../../../enums/ViewType";
import {SimpleSearchWithId} from "../../../../reduxToolkit/Search/SearchApi";

const SubCategoriesApp = () => {
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const [tableId, setTableId] = useState('tbl_sca_subcategories');
    const [searchId, setSearchId] = useState('txt_sca_subcategories');
    const [modified, setModified] = useState(null);
    const { categoryAndSubcategory } = useSelector((state) => state.equipmentSlice);
    const [results, setResults] = useState(categoryAndSubcategory);
    const [searchElement, setSearchElement] = useState(''); // Search filter value
    const [simpleSearch, setSimpleSearch] = useState(false); // Simple search flag
    const [search, setSearch] = useState(false); // Search flag
    const [bodyForExport, setBodyForExport] = useState('');
    const [contractorId, setContractorId] = useState(sessionStorage.getItem('contractorId'));
    const [supplierId, setSupplierId] = useState(sessionStorage.getItem('providerId'));
    const [deleteShow, setDeleteShow] = useState(false); // Controls delete confirmation modal visibility
    const [selectedCategoryForDelete, setSelectedCategoryForDelete] = useState(null); // Stores the selected category ID to be deleted
    const [createSubCategoryShow, setCreateSubCategoryShow] = useState(false); // Controls visibility of the "Create Subcategory" modal
    const [isAllChecked, setIsAllChecked] = useState(false);
    // API table option used for delete operation
    const option = TABLES.CATEGORY;
    const viewType = VIEW_TYPE.GRID.viewType;
    const elementRef = useRef(null);

    // Generates the table header configuration
    const getThead = () => {
        return [<CustomTh tableId={tableId}  classes='first_head'></CustomTh>];
    };

    // Function to generate the table body
    const getTbody = () => {
        if (!results || results?.content?.length === 0)
            return {
                body: [],
                data: [],
            };

        let body = results?.content?.map((item) => {
            return (
                <>
                    <CustomTd tableId={tableId} tooltip={item?.name}  classes='first-column'>
                        {item?.name || EMPTY_VALUES.DEFAULT}
                    </CustomTd>
                </>
            );
        });

        return { body, data: results?.content };
    };

    // Renders action buttons for each row (dropdown menu)
    const getActionsButtons = (item, index) => {
        return (
            <>
                <DropDownMenuProfile openMenu={openMenu} handleMenuToggle={handleMenuToggle} menuId={`menu-${item.id}`}>
                    <DropDownMenuItem
                        index={item?.id}
                        handleClose={handleClose}
                        name={t('delete')}
                        fontColor='font-color-error-600'
                        iconColor={'icon-color-error-code-600'}
                        click={() => {
                            handleDelete(item);
                        }}
                        icon={<DeleteIconsOptions />}
                    />
                </DropDownMenuProfile>
            </>
        );
    };

    // Opens delete confirmation modal and stores selected item ID
    const handleDelete = (item) => {
        setSelectedCategoryForDelete({
            ...item,
            category: option,
        });
        setDeleteShow(true);
    };

    // Executes delete action through API
    const deleteCategory = (item) => {
        dispatch(
            DeleteItemsApi({
                tableName: option,
                body: [item.id],
            }),
        ).then(
            ({
                payload: {
                    data: { success, code },
                },
            }) => {
                if (success) {
                    setDeleteShow(false);
                    setSelectedCategoryForDelete(null);
                    setModified(true);
                } else {
                    errorMsg(code);
                }
            },
        );
    };

    /**
     * Executes a paginated search request using basic criteria.
     *
     * Builds the request body with the current page, page size, selected model,
     * and any additional criteria passed as arguments.
     * Triggers the search action through Redux and updates the results on success.
     */
    const getData = ( page, { searchElement }) => {
        const body = SEARCH_MODEL.setObject({page, size:rowsPerPage, model:option, key:searchElement, userId:contractorId, viewType: VIEW_TYPE.GRID.viewType});//VIEW_TYPE.LIST.viewType == CATEGORY identifier
        dispatch(SimpleSearchWithId({ body })).then(
            ({payload: {data: { data, success }}}) => {
                if (success === true) {
                    setResults(data);
                }
            },
        );
    };

    const { thead, tbody, pagination, page, rowsPerPage, handleMenuToggle, handleClose, openMenu } = TableFunction({
        data: results,
        getThead,
        getTbody,
        labelRowsPerPage: 'sub_categories_per_page',
        fixedPagination: false,
        hasContainer: true,
        setIsAllChecked,//New
        searchElement, //New
        getData,//New
        modified,//New
        setModified,//New
    });

    return {
        t,
        tableId,
        searchId,
        thead,
        tbody,
        getActionsButtons,
        pagination,
        contractorId,
        supplierId,
        searchElement,
        setSearchElement,
        setResults,
        option,
        page,
        rowsPerPage,
        setSearch,
        setSimpleSearch,
        setBodyForExport,
        deleteShow,
        setDeleteShow,
        selectedCategoryForDelete,
        deleteCategory,
        createSubCategoryShow,
        setCreateSubCategoryShow,
        setModified,
        viewType,
        isAllChecked,
        elementRef
    };
};

export default SubCategoriesApp;
